import React from 'react';
import { connect } from 'react-redux';
import { Form, Col, Button, Modal } from 'react-bootstrap';
import { fetchLedModules } from '../../../../../actions';
import { LED_MODULE } from '../../../../../utils/constantFeatures';

class ProjectInfoLedModule extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ledModule: '',
            isShowingResetCurrent: false,
        };
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.properties !== prevProps.properties) {
            this.props.fetchLedModules()
                .then(() => {
                    const ledModuleProperty = this.getLedModuleProperty();
                    if (ledModuleProperty) {
                        const ledModuleSelected = this.props.ledmodules.filter(x => x.id === parseInt(ledModuleProperty.value))[0];
                        this.setState({ ledModule: ledModuleSelected.id });
                    }
                })
                .catch(() => {
                });
        }
    }

    getLedModuleProperty() {
        if (this.props.properties) {
            for (var i=0; i<this.props.properties.length; i++) {
                if (this.props.properties[i].info.name === LED_MODULE.id) {
                    return this.props.properties[i];
                }
            }
        }
        return null;
    }

    handleChangeDropdown(e) {
        const v = e.target.value;

        this.setState({isShowingResetCurrent: true});

        this.setState({ ledModule: v });
        const property = this.getLedModuleProperty();
        if (property) {
            property.value = v;
            this.props.handleChange(property);
        }
    }

    renderDropdownItems() {
        let dropdownItems = [];
        const property = this.getLedModuleProperty();
        return <>
            {!property || property.value === '0' && (
                <option value={"0"} key={"0"}>
                    {" Select LED Module "}
                </option>
            ) }
            <optgroup label="Released LED modules">
                {this.props.ledmodules.filter(prop=>prop.id < 32000).map(prop => (
                    <option value={prop.id} key={prop.id}>
                        {prop.name}
                    </option>
                )) }
            </optgroup>

            <optgroup label="Customer LED modules (removable)">
                {this.props.ledmodules.filter(prop=>prop.id >= 32000).map(prop => (
                    <option value={prop.id} key={prop.id}>
                        {prop.name}
                    </option>
                )) }
            </optgroup>
        </>

        // if (!property || property.value === '0') {
        //     dropdownItems.push(
        //         <option value={"0"} key={"0"}>
        //             {" Select LED Module "}
        //         </option>
        //     );
        // }

        // this.props.ledmodules.forEach(prop => {
        //     dropdownItems.push(
        //         <option value={prop.id} key={prop.id}>
        //             {prop.id} {prop.name}
        //         </option>
        //     );
        // });

        // return dropdownItems;
    }

    render() {

        if (!this.props.ledmodules) {
            return (
                <Form.Group as={Col} md="3" controlId="name" style={{ margin: '0', display: "flex" }}>
                    <Form.Label className="required" style={{ fontWeight: "700" }}>Load LED Module</Form.Label>
                    <Form.Control
                        disabled
                        value={'Loading'}
                        placeholder="0" />
                </Form.Group>
            );
        }
        return(
            <Form.Group as={Col} md="3" controlId="name" style={{ margin: '0', display: "flex" }}>
                <Form.Label className="required" style={{ fontWeight: "700" }}>Load LED Module</Form.Label>
                <Form.Control as="select"
                    onChange={this.handleChangeDropdown}
                    placeholder="Select LED Module"
                    value={this.state.ledModule}
                    multiple={false} >
                    {this.renderDropdownItems()}
                </Form.Control>

                <Modal show={this.state.isShowingResetCurrent} onHide={() => this.setState({isShowingResetCurrent: false})} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#E95B0D" }}>Warning</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            Changing modularity will reset current settings to default
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({isShowingResetCurrent: false}) }>Close</Button>
                    </Modal.Footer>
                </Modal>
            </Form.Group>

        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ledmodules: state.ledModules.ledmodules
    };
};

const mapDispatchToProps = {
    fetchLedModules
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectInfoLedModule);
